// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40')
];

export const server_loads = [];

export const dictionary = {
		"/(authenticated)": [6,[2]],
		"/(authenticated)/(admin)/admin": [7,[2,3]],
		"/(authenticated)/(admin)/admin/[...rest]": [8,[2,3]],
		"/(authenticated)/after-payment": [9,[2]],
		"/(authenticated)/book-links": [10,[2,4]],
		"/(authenticated)/book-links/[pdfId]": [11,[2,4]],
		"/book/[code]": [29],
		"/(authenticated)/checkout": [12,[2]],
		"/digital-guide": [30,[5]],
		"/digital-guide/book/[bookId]": [31,[5]],
		"/(authenticated)/eeonline": [13,[2]],
		"/faq": [32],
		"/(authenticated)/invitations": [14,[2]],
		"/(authenticated)/invite/[id]": [15,[2]],
		"/login": [33],
		"/mcp-authorize": [34],
		"/mcp-setup": [35],
		"/migrate": [36],
		"/(authenticated)/organization": [16,[2]],
		"/(authenticated)/organization/new": [19,[2]],
		"/(authenticated)/organization/[id]": [17,[2]],
		"/(authenticated)/organization/[id]/invoices": [18,[2]],
		"/(authenticated)/pending-payment": [20,[2]],
		"/(authenticated)/playlists": [22,[2]],
		"/(authenticated)/playlist/[id]": [21,[2]],
		"/(authenticated)/portal/[[language]]/[[chapter]]/[[section]]": [23,[2]],
		"/pricing": [37],
		"/pricing/organization": [38],
		"/register": [39],
		"/(authenticated)/settings": [24,[2]],
		"/verify-email": [40],
		"/(authenticated)/voice-plans/[[category]]": [27,[2]],
		"/(authenticated)/voice-plan/new": [26,[2]],
		"/(authenticated)/voice-plan/[id]": [25,[2]],
		"/[...rest]": [28]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);